import React, { FC, Ref, useRef } from 'react'
import { Popup } from '../../catalog/Popup'
import { Swap } from '../../../logic/swaps/Swap'
import styled from 'styled-components'
import ValidationButton from '../../catalog/ValidationButton'
import { ViewState } from '../../pools/deposit/DepositState'
import { extractErrorFromState } from '../../../logic/errors/extract-error-message'
import { ErrorMessage } from '../../catalog/ErrorMessage'

interface Props {
  errorMessage: string
  onExit: VoidFunction
}

export const FailPostSwapPopup: FC<Props> = (props: Props) => {
  const { onExit, errorMessage } = props

  const ref = useRef()
  return (
    <PopupWrapper>
      <Popup outsideRef={ref} onExit={onExit} title={'Failed transaction'}>
        <ErrorMessage className="mt20">{errorMessage}</ErrorMessage>
        <ValidationButton className="mt20" isReady={true} onClick={onExit}>
          {'Done'}
        </ValidationButton>
      </Popup>
    </PopupWrapper>
  )
}

// TODO: include this in the Popup component
const PopupWrapper = styled.div`
  font-size: 0.85em;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 100;
`
